import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const colorMap = {
	green: { bg: 'status.green.bg', color: 'status.green.text' },
	amber: { bg: 'status.amber.bg', color: 'status.amber.text' },
	red: { bg: 'status.red.bg', color: 'status.red.text' },
	blue: { bg: 'status.blue.bg', color: 'status.blue.text' },
	teal: { bg: 'status.teal.bg', color: 'status.teal.text' },
	gray: { bg: 'status.gray.bg', color: 'status.gray.text' },
	vdr: {
		bg: 'vdr.bg',
		color: 'vdr.text',
		border: '0.5px solid',
		borderColor: 'vdr.border',
	},
};

const StatusPill = ({
	label,
	color = 'gray',
	clickable,
	onClick,
	sx: sxOverride,
}) => {
	const colors = colorMap[color] || colorMap.gray;

	return (
		<Box
			component='div'
			onClick={onClick}
			sx={{
				display: 'inline-flex',
				alignItems: 'center',
				fontSize: '10px',
				fontWeight: 600,
				lineHeight: 1.5,
				padding: '2px 7px',
				borderRadius: '9px',
				whiteSpace: 'nowrap',
				backgroundColor: colors.bg,
				color: colors.color,
				border: colors.border || 'none',
				borderColor: colors.borderColor,
				cursor: clickable || onClick ? 'pointer' : 'default',
				textDecoration: clickable ? 'underline dotted' : 'none',
				textUnderlineOffset: '2px',
				'&:hover': clickable ? { filter: 'brightness(.92)' } : {},
				...sxOverride,
			}}
		>
			{label}
		</Box>
	);
};

StatusPill.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	color: PropTypes.oneOf([
		'green',
		'amber',
		'red',
		'blue',
		'teal',
		'gray',
		'vdr',
	]),
	clickable: PropTypes.bool,
	onClick: PropTypes.func,
	sx: PropTypes.object,
};

export default StatusPill;
